import { Component, OnInit, TemplateRef, Input, ContentChild, Output, EventEmitter, ViewChild } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service'
import { FormGroup, FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators'

@Component({
  selector: 'search-modal',
  templateUrl: './search-modal.component.html',
  styleUrls: ['./search-modal.component.scss']
})
export class SearchModalComponent implements OnInit {
  @Input() public searchFormGroup: FormGroup;
  @Output() public select = new EventEmitter<any>();
  @Output() public onContinue = new EventEmitter<any>();
  @Output() public onResults = new EventEmitter<any>();
  @Input() public showContinue:boolean = false;
  @Input() public service: any;
  @Input() public searchFnName: string;
  @Input() public showSearchForm: boolean = true;
  @Input() public showButton: boolean = true;
  @Input() public class: string = '';
  @Input() public labelField: string = '';
  @Input() public displayMessage: string = "";
  @ViewChild('modal') modal: TemplateRef<any>;
  @ContentChild('formResult') searchResultTemplate: TemplateRef<any>;

  searchResults: any[] = [];
  modalRef: BsModalRef;

  constructor(private modalService: BsModalService) { }

  ngOnInit() {
  }

  openModal() {
    console.log("Search results are: ", this.searchResults);

    let activeElement = document.activeElement;

    this.modalRef = this.modalService.show(this.modal, { class: this.class, ignoreBackdropClick: true });

    this.modalRef.onHide.pipe(first()).subscribe(() => {
      if (activeElement && activeElement instanceof HTMLElement) {
        activeElement.focus();
      }
    });
  }
  onContinueClick($event){
    this.modalRef.hide();
    this.onContinue.emit($event);
  }
  closeModal(){
    this.modalRef.hide();
    return false;
  }
  onSearch() {
    (this.service[this.searchFnName](this.searchFormGroup.value) as Observable<any>).subscribe((results: any) => {
      this.searchResults = results.model || results;
      this.onResults.emit({result:this.searchResults,request:this.searchFormGroup.value});
    });
  }
  onSearchObj(searchValues={}) {
    (this.service[this.searchFnName](searchValues) as Observable<any>).subscribe((results: any) => {
      this.searchResults = results.model || results;
      this.onResults.emit({result:this.searchResults,request:this.searchFormGroup.value});
    });
  }
  onSelect(selectedResult) {
    this.select.emit(selectedResult);
    this.modalRef.hide();
  }

}
